import React, { useEffect } from 'react';
import useAuth from '../../hooks/useAuth';
import { useLocation, navigate } from '@reach/router';
import ROUTES from '../../routes';

interface IPrivateRoute {
  component: React.ComponentType<any>;
  redirectUrl?: string;
  rest?: any[];
  path: string;
}

const PrivateRoute = ({
  component: Component,
  redirectUrl,
  ...rest
}: IPrivateRoute) => {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      navigate(redirectUrl || ROUTES.SIGN_IN, {
        state: { redirectUrl: `${location.pathname}${location.search}` },
        replace: true,
      });
    }
  }, [isAuthenticated, isLoading]);

  // Don't render the component until authenticated
  if (isLoading || !isAuthenticated) {
    return null;
  }
  return <Component {...rest} />;
};

export default PrivateRoute;
